import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MapPinIcon } from 'lucide-react';
const names = ['Matías', 'Lucas', 'Federico', 'Martín', 'Diego', 'Alejandro', 'Nicolás', 'Gonzalo', 'Pablo', 'Julián', 'Facundo', 'Emiliano', 'Tomás', 'Leandro', 'Maximiliano'];
const cities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Tucumán', 'La Plata', 'Mar del Plata', 'Salta', 'Santa Fe', 'Neuquén'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      setCurrentBuyer({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    // Initial delay before first popup
    const initialTimeout = setTimeout(() => {
      showPopup();
      // Set up recurring popups
      const interval = setInterval(() => {
        // Random interval between 8 and 12 seconds
        const nextDelay = Math.floor(Math.random() * (12000 - 8000 + 1) + 8000);
        setTimeout(showPopup, nextDelay);
      }, 10000); // Base interval, actual timing handled by inner setTimeout
      return () => clearInterval(interval);
    }, 5000);
    return () => clearTimeout(initialTimeout);
  }, []);
  return <AnimatePresence data-id="element-145">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.95
    }} transition={{
      duration: 0.4,
      ease: 'easeOut'
    }} className="fixed bottom-4 left-4 z-50 max-w-sm bg-gray-900 border border-gold/30 rounded-lg shadow-2xl shadow-gold/10 p-4 flex items-start gap-3" data-id="element-146">
          <div className="bg-gold/20 p-2 rounded-full mt-1" data-id="element-147">
            <span className="text-xl" data-id="element-148">🔥</span>
          </div>
          <div data-id="element-149">
            <p className="text-sm font-medium text-white" data-id="element-150">
              <span className="font-bold text-gold" data-id="element-151">{currentBuyer.name}</span>{' '}
              de {currentBuyer.city}
            </p>
            <p className="text-xs text-gray-300 mt-1" data-id="element-152">
              acaba de comprar Entrenador de Futsal 360°
            </p>
            <div className="flex items-center gap-1 mt-2 text-[10px] text-gray-400" data-id="element-153">
              <MapPinIcon size={10} data-id="element-154" />
              <span data-id="element-155">Hace unos minutos</span>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}